import { AdminApi, AuthApi, PublicApi } from '@guiker/recommended-listing-api-definition'
import { config } from '@guiker/recommended-listing-config'
import { generateApiClient } from '@guiker/rest-client'

export const PublicApiClient = generateApiClient(config.apiName, PublicApi.routes)
export const AuthenticatedApiClient = generateApiClient(config.apiName, AuthApi.routes)
export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
